<script lang="ts">
export interface PhxsgStackProps {
  spacing?: string | number;
  align?: 'start' | 'center' | 'end' | 'baseline';
  recursive?: boolean;
  use?: keyof HTMLElementTagNameMap;
}
</script>

<script setup lang="ts">
const { use = 'div', recursive = false } = defineProps<PhxsgStackProps>();
</script>

<template>
  <component
    :is="use"
    :class="[
      'phxsg-stack',
      {
        [`phxsg-stack--spacing-${spacing}`]: spacing,
        [`phxsg-stack--align-${align}`]: align,
        'phxsg-stack--recursive': recursive,
      },
    ]"
  >
    <slot />
  </component>
</template>

<style src="./stack.css" />
